import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";
import { ensureGtag } from "@/lib/tracking";

// Carga gtag.js en las páginas de la tienda (nunca en /admin) cuando la
// integración de Google Ads está activada para este tenant.
export default function GAds() {
  const { cfg } = useTheme();
  const location = useLocation();
  const ga = cfg?.googleAds;
  const activo = Boolean(ga?.activo && ga?.id) && !location.pathname.startsWith("/admin");

  useEffect(() => {
    if (activo) ensureGtag(ga.id);
  }, [activo, ga?.id]);

  return null;
}
